// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table td[data-v-ff78e62a],\n.table th[data-v-ff78e62a] {\n  padding: 0.75rem;\n  vertical-align: top;\n  border-bottom: 1px solid #dee2e6;\n  border: 2px solid #82c1ea;\n}\n.member-overlap-item[data-v-ff78e62a] {\n  margin-right: -10px;\n}\n.group[data-v-ff78e62a] {\n  min-height: 40px;\n  height: 66px;\n  line-height: 66px;\n}", ""]);
// Exports
module.exports = exports;
